import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { api } from "@/lib/api";
import { applySeo, PageLoader, useFetch } from "@/lib/hooks";
import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { ServicesSection, WhyChoose } from "@/components/site/InfoSections";
import { OurWork } from "@/components/site/OurWork";
import { ReviewsSection } from "@/components/site/ReviewsSection";
import { ContactSection } from "@/components/site/ContactSection";
import { Footer, StickyBar } from "@/components/site/StickyBar";

export default function Landing() {
  const [reload, setReload] = useState(0);
  const { data, error } = useFetch(() => api.get("/public/site"), [reload]);
  const location = useLocation();

  useEffect(() => {
    if (!data) return;
    applySeo(data.settings);
    if (location.hash) {
      const id = location.hash.slice(1);
      requestAnimationFrame(() => document.getElementById(id)?.scrollIntoView({ block: "start" }));
    }
  }, [data, location.hash]);

  if (error)
    return (
      <div className="grid min-h-screen place-items-center p-6 text-center text-zinc-300" data-testid="landing-error">
        We couldn't load the page. Please refresh in a moment.
      </div>
    );
  if (!data) return <PageLoader />;
  const s = data.settings;
  return (
    <div className="min-h-screen bg-[#121214]" data-testid="landing-page">
      <Header settings={s} />
      <main>
        <Hero settings={s} />
        <WhyChoose points={data.points} />
        <ServicesSection services={data.services} />
        <OurWork projects={data.projects} />
        <ReviewsSection reviews={data.reviews} summary={data.review_summary} onChanged={() => setReload((n) => n + 1)} />
        <ContactSection settings={s} services={data.services} />
      </main>
      <Footer settings={s} />
      <StickyBar phone={s.primary_phone} />
    </div>
  );
}
